import { useEffect, useState } from "react";
import { t } from "../i18n/en";

/** Says so when the device has no connection, rather than leaving a frozen map to be mistaken for
 *  a quiet sky. */
export default function OfflineBanner() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);
  if (online) return null;
  return <div className="offline-banner">{t.errors.offline}</div>;
}
